/* eslint-disable max-len */
import React, { SVGAttributes } from 'react';

export default ({ color = '#FFF', ...props }: SVGAttributes<SVGElement> & { color?: string }) => (
	<svg width="28px" height="28px" {...props} viewBox="0 0 28 28">
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g transform="translate(-6.000000, -6.000000)">
				<path
					d="M29.4166667,10.5833333 C27,8.16666667 23.6833333,6.66666667 20,6.66666667 C12.6333333,6.66666667 6.68333333,12.6333333 6.68333333,20 C6.68333333,27.3666667 12.6333333,33.3333333 20,33.3333333 C26.2166667,33.3333333 31.4,29.0833333 32.8833333,23.3333333 L29.4166667,23.3333333 C28.05,27.2166667 24.35,30 20,30 C14.4833333,30 10,25.5166667 10,20 C10,14.4833333 14.4833333,10 20,10 C22.7666667,10 25.2333333,11.15 27.0333333,12.9666667 L21.6666667,18.3333333 L33.3333333,18.3333333 L33.3333333,6.66666667 L29.4166667,10.5833333 Z"
					fill={color}
				/>
			</g>
		</g>
	</svg>
);
